/**
 * create on 2019.07.11
 * 功能模块生效时间
 */
'use strict'
angular.module('effectiveTimeModule', [])
    .controller('effectiveTimeCtrl', ['$scope', '$q', '$modalInstance', 'item', 'trsHttpService',
        function($scope, $q, $modalInstance, item, trsHttpService) {
            initData()
            initStatus()
                /** [initData description]初始化数据 */
            function initData() {
                let deffer = $q.defer();
                let params = {
                    "serviceid": "mlf_billing",
                    "methodName": "queryRelsByTenantId",
                    "TenantId": item.TENANTID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then(function(result) {
                    $scope.status.items = result == '' ? [] : result;
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    childTableShowFlag: true,
                    items: [],
                };

            }
            /** [cancel description]关闭弹窗 */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ])